import React, { useEffect } from 'react';

// Components
import { ChatListCell, TableView } from '../../';

// Classes & Types
import { Room } from '@breakroom-nx/classes';

// Redux
import {
  useGetChatsForUserQuery,
  useGetLastMessagesForRoomsQuery,
} from '@breakroom-nx/redux';
import { ChatType } from '@breakroom-nx/helpers';
import { getAuth } from 'firebase/auth';

export interface ChatListTableViewProps {
  type: ChatType;
  noChatsNotification: string;
}

export function ChatListTableView({
  type,
  noChatsNotification,
}: ChatListTableViewProps) {
  const auth = getAuth();
  const currentUser = auth.currentUser;
  const {
    data: chats,
    isLoading,
    isSuccess,
    isError,
    error,
    refetch,
  } = useGetChatsForUserQuery({
    uid: currentUser?.uid,
    chatType: type,
  });

  const { data: sortedRooms, isLoading: isLoadingLastMessages } =
    useGetLastMessagesForRoomsQuery(chats ?? [], {
      skip: !chats || chats.length === 0,
    });

  useEffect(() => {
    // console.log(`New Chat Found: ${chats}`);
    // console.log(`Chats Rendered: ${JSON.stringify(sortedRooms)}`);
    // console.log(`Last Messages: ${sortedRooms?.length}`);
  }, [chats]);

  useEffect(() => {
    // console.log(`Rendering Chat List Table View`);
  });

  const renderChats = () => {
    if (sortedRooms && sortedRooms.length > 0) {
      return sortedRooms.map((room: Room) => {
        return <ChatListCell room={room} key={room.id} />;
      });
    } else {
      return;
    }
  };

  return (
    <TableView
      isLoading={isLoading}
      isSuccess={isSuccess}
      isError={isError}
      error={error}
      noData={!chats || chats.length < 1}
      noDataString={noChatsNotification}
      onRefetch={refetch}
      pb={150}
    >
      {renderChats()}
    </TableView>
  );
}

const MemoChatListTableView = React.memo(ChatListTableView);
export { MemoChatListTableView };
